export const motiveTranslator = (motive) => {
  if (!motive || motive === 'OTHER') return null;

  const familyRelationship = [
    'MOTHER',
    'FATHER',
    'BROTHER',
    'GRANDSON',
    'GRANDPARENT',
    'SON',
    'NEPHEW',
    'SPOUSE',
    'UNCLE',
    'COUSIN',
  ];

  if (motive === 'STATE EMPLOYEE') {
    return 'pages.private.profiles.components.dataSourceCards.restrictiveLists.utils.translator.motiveTranslator.STATE_EMPLOYEE';
  }

  if (motive === 'CITY EMPLOYEE') {
    return 'pages.private.profiles.components.dataSourceCards.restrictiveLists.utils.translator.motiveTranslator.CITY_EMPLOYEE';
  }

  if (motive === 'FEDERAL EMPLOYEE') {
    return 'pages.private.profiles.components.dataSourceCards.restrictiveLists.utils.translator.motiveTranslator.FEDERAL_EMPLOYEE';
  }

  if (familyRelationship.includes(motive) || motive === 'RELATIVE') {
    return 'pages.private.profiles.components.dataSourceCards.restrictiveLists.utils.translator.motiveTranslator.politicallyExposedFamilyMember';
  }

  return motive;
};
